export const all = (state) => state.user.update;
export const loading = (state) => all(state).loading;
export const error = (state) => all(state).error;
